export class ClassroomSummaryPreferences {
    static V10AllOptions: string[] = [];
    static V9AllOptions: string[] = [];
    AvailableOptions: string[] = [];
    AvailableColumns: ClassroomSummaryColumns[] = [];
    OptionsToShow: string[] = [];
    GridColumns = [];
    TermId: number;
    ViewId: number;
    IncludeEmptySections: boolean;
    HideEmptyAlerts: boolean;
   }

export class ClassroomSummaryColumns {
    Field: string;
    Name: string;
    Width: number;
}